//@flow
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Dashboard from './Dashboard';
export default class DashboardIndex extends React.PureComponent<{}> {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route path="/dashboard" component={Dashboard} />
        </Switch>
      </React.Fragment>
    );
  }
}
